import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dynamicCollectionRendererKey } from '@epicuro-next/constants/dynamic-elements';
import { DynamicElementsTooltipDirective } from '@epicuro-next/dynamic-elements/dynamic-tooltip';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

import { IComponentOptions } from '../../services/components-resolver.service';

@Component({
  selector: 'epc-' + dynamicCollectionRendererKey,
  templateUrl: './collections-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: DynamicElementsTooltipDirective,
      inputs: ['tooltip'],
    },
  ],
  standalone: false,
})
@DynamicComponentRegister(dynamicCollectionRendererKey)
export class CollectionsRendererComponent {
  private static readonly itemsKey: keyof CollectionsRendererComponent =
    'items';
  public readonly name = dynamicCollectionRendererKey;

  // tslint:disable-next-line:variable-name
  private _items: IDynamicItem[];

  @Input()
  public isRoot = false;

  @Input()
  public set items(value: IDynamicItem[]) {
    if (this.isRoot && value.length > 1) {
      value = [
        {
          contentTypeId: 'dynamic-collections-renderer',
          children: value,
        },
      ];
    }
    this._items = value;
  }

  public get items(): IDynamicItem[] {
    return this._items;
  }

  @Input()
  public parent: object;

  @Input()
  public set scope(value: object) {
    this.__scope__ = value;
  }
  public get scope(): object {
    return this.__scope__ ?? this;
  }
  // tslint:disable-next-line:variable-name
  private __scope__: object;

  @Input()
  public trackByFunction!: any;

  /**
   * Setting `children` on dynamic-collections-renderer causes unexpected lay-out rendering.
   * Therefore moving children to inputs.items if it is detected children is used.
   */
  public static ensureChildrenAreSetInItemsInput(options: {
    children?: IComponentOptions['children'];
    inputs?: IComponentOptions['inputs'];
  }) {
    if (options?.children === undefined || options.children.length === 0) {
      return;
    }

    const items = options.inputs?.[CollectionsRendererComponent.itemsKey];
    const inputItems = `inputs['${CollectionsRendererComponent.itemsKey}']`;
    if (items && Array.isArray(items) && items.length > 0) {
      console.warn(
        `Cannot have both ${inputItems} and children on component ${dynamicCollectionRendererKey}.
        Please move all items to ${inputItems}.`,
      );
    } else {
      options.inputs ??= {};
      options.inputs[CollectionsRendererComponent.itemsKey] = [
        ...options.children,
      ];
      options.children = undefined;
    }
  }
}
